import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../models/user.model';
import { VenueConfiguration } from '../models/venue-config.model';
import { Auth0ChangePasswordTicketModel} from '../models/auth0-change-password.model';
import { catchError, retry, take } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Injectable()
export class UserService {
  //private readonly url: string = 'https://localhost:5001/'; //uncomment these 2 lines for debugging (launch DFS.Venue.UserProfile.Api on https://localhost:5001 with Kestrel)
  //private readonly updLangUrl: string = 'https://localhost:5001/User/UpdateLanguage';  
  //private featureToggleUrl: string = 'https://venue231wa2.dom01.rrdsecure.dev:14550/app/users/api/context/featuretoggles';  
  private auth0ChangePasswordUrl: string = '/api/env/PasswordResetRequests/ChangePasswordUrl';
  private featureToggleUrl: string = '/api/context/featuretoggles';
  private readonly url: string = 'Api/UserProfile/';
  private readonly updLangUrl: string = 'Api/UserProfile/User/UpdateLanguage';

  constructor(private http: HttpClient) { }

  public getUser(guid: string): Observable<User> {
    return this.http.get<User>(this.url.concat(guid));
  }

  public updateUserLanguage(model: User): Observable<User> {
    return this.http.put<User>(this.updLangUrl, model)
      .pipe(
        take(1),
        catchError(this.handleError)
      );
  }

  public getUserFeatureToggles(domain: string): Observable<Map<string, string>> {
    const togglesMap: Map<string, string> = new Map<string, string>();   
    return this.http.get<any>(domain.concat(this.featureToggleUrl)) 
    .pipe(
      map(data => {
        data.forEach(toggle => togglesMap.set(toggle.key, toggle.value));
        return togglesMap;
      })
    );
  }

  public getChangePasswordRequest(domain: string): Observable<string>{
    return this.http.get<any>(domain.concat(this.auth0ChangePasswordUrl));     
  }

  public getAuth0ChangePasswordRequest(domain: string, emailId: string): Observable<Auth0ChangePasswordTicketModel>{
    var headers = new HttpHeaders();
    headers = headers.append('Email', emailId);
    return this.http.get<Auth0ChangePasswordTicketModel>(domain.concat(this.auth0ChangePasswordUrl), {headers: headers});  
  }

  public getFeatureTogglesUrl(): Observable<VenueConfiguration>{   
    return this.http.get<VenueConfiguration>(this.url.concat('VenueConfiguration/UrlVenueAppUsers'));  
  }

  public getUserMock(): User {
    return new User();
  }

  private handleError(error: { error: { message: any; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
